<template>
  <div class="overflow-hidden modal">
  <!-- overlay -->
    <transition
      name="overlay"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <portal to="overlay">
        <div class="fixed pin z-20" v-if="isModalVisible">
          <div
            @click="hideModal()"
            class="absolute pin bg-black opacity-25"></div>
        </div>
      </portal>
    </transition>
    <!-- end overlay -->

    <transition
      name="paths"
      leave-active-class="animated fadeOut faster"
      enter-active-class="animated fadeIn faster"
    >

      <portal to="modal">
        <div v-if="isModalVisible"
          class="fixed pin flex modal overflow-auto z-40">
          <div
            class="relative bg-gray-lightest w-full flex-col flex overflow-auto p-8">
            <div class="container mx-auto">
              <div class="lg:w-1/2 m-auto">


                <div class="items-center">

                  <div @click="hideModal()"
                    class="text-xs cursor-pointer underline text-full-blue"
                  >Back</div>

                  <div class="flex justify-between items-center pb-6">
                    <h2 class="text-2xl py-4 font-bold">Add Note</h2>
                  </div>

                </div>

                <add-record-form @complete="hideModal" :isFocused="true" :isInModal="true" />
              </div>
            </div>
          </div>
        </div>
      </portal>
    </transition>
  </div>
</template>

<script>
 import path from 'path';
 import AddRecordForm from './AddRecordForm';

 export default {
   props: {
     isModalVisible: {
       type: Boolean,
       default: false
     }
   },

   components: {AddRecordForm},

   methods: {
     hideModal (message) {
       this.$emit('close');
     },
   },

   watch: {
     isModalVisible(to, from) {
       if (from === false && to === true) {
         this.rerender = true;
       }
     }
   }
 }

</script>

